import { AnyAction } from 'redux'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import { apiRosterSyncActions } from './apiRosterSyncSlice'
import ApiRosterSyncService from './apiRosterSyncService'
import {
  generateApiKey,
  getRosterSync,
  revokeApiKey,
  updateRosterSyncSettings,
} from './apiRosterSyncActions'
import { employerActions } from 'redux/employer/employerSlice'
import { getApiErrorDetail } from './apiRosterSyncUtils'

export function* getRosterSyncSaga(_action: AnyAction) {
  try {
    const [settingsRes, keysRes] = yield all([
      call(ApiRosterSyncService.getSettings),
      call(ApiRosterSyncService.getKeys),
    ])
    yield put(
      apiRosterSyncActions.getRosterSyncSuccess({
        settings: settingsRes.data,
        keys: keysRes.data ?? [],
      })
    )
  } catch {
    yield put(apiRosterSyncActions.getRosterSyncFailed())
  }
}

export function* updateRosterSyncSettingsSaga(action: AnyAction) {
  yield put(apiRosterSyncActions.setSaving(true))
  try {
    const res = yield call(ApiRosterSyncService.updateSettings, action.payload)
    yield put(apiRosterSyncActions.updateSettingsSuccess(res.data))
    yield put(
      employerActions.setApiRosterSyncEnabled(Boolean(res.data.enabled))
    )
  } catch (error) {
    yield put(
      apiRosterSyncActions.updateSettingsFailed(getApiErrorDetail(error))
    )
  }
}

export function* generateApiKeySaga(action: AnyAction) {
  yield put(apiRosterSyncActions.setSaving(true))
  try {
    const res = yield call(
      ApiRosterSyncService.generateKey,
      action.payload?.name
    )
    yield put(apiRosterSyncActions.generateKeySuccess(res.data))
  } catch (error) {
    yield put(apiRosterSyncActions.generateKeyFailed(getApiErrorDetail(error)))
  }
}

export function* revokeApiKeySaga(action: AnyAction) {
  yield put(apiRosterSyncActions.setSaving(true))
  try {
    const res = yield call(ApiRosterSyncService.revokeKey, action.payload)
    yield put(apiRosterSyncActions.revokeKeySuccess(res.data))
  } catch (error) {
    yield put(apiRosterSyncActions.revokeKeyFailed(getApiErrorDetail(error)))
  }
}

export default function* apiRosterSyncSaga() {
  yield all([
    takeEvery(getRosterSync.type, getRosterSyncSaga),
    takeEvery(updateRosterSyncSettings.type, updateRosterSyncSettingsSaga),
    takeEvery(generateApiKey.type, generateApiKeySaga),
    takeEvery(revokeApiKey.type, revokeApiKeySaga),
  ])
}
